import React from 'react'
import PropTypes from "prop-types"
import { get, values, chain } from 'lodash'
import { Panel, Checkbox, ButtonGroup } from 'react-bootstrap'
import Button from '../../components/Button.jsx'
import MarkdownField from '../../lib/MarkdownField'
import FormatHelpModal from './FormatHelpModal'
import DeleteModal from './DeleteModal'
import AddExceptionModal from './AddExceptionModal'

import {
  editException,
  editExceptionOpen,
  editExceptionNote,
  editAllDayException,
  parseException,
  parseAllDayException,
  deleteAny,
  timetablePropType
} from '../timetable'

const regexHour = '\\d\\d\\:\\d\\d'
const regexRange = `${regexHour}\\-${regexHour}`

const regularRegex = string => new RegExp(`^\\s*${regexHour}(\\s*\n+${regexHour})*\n*$`, "g").test(string)
const allDayRegex = string => new RegExp(`^\\s*${regexRange}(\\s*\n+${regexRange})*\n*$`, "g").test(string)

export default class ExceptionsEditor extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      formatHelpModal: false,
      startedNotes: {}
    }
  }

  startNote(key) {
    this.setState({ startedNotes: { ...this.state.startedNotes, [key]: true } })
  }

  componentDidMount() {
    const initialState = {}

    values(this.props.timetable.exceptions)
      .filter(excp => excp.key)
      .forEach(exception => {
        initialState[exception.key] = { value: parseException(exception), regexp: true, allDayTimes: parseAllDayException(exception), isOpen: exception.isOpen }
      })

    this.setState(initialState)
  }

  getExceptionColor(exception) {
    if (!get(this.state, [exception.key, 'value'])) return "darkgrey"
    else if (get(this.state, [exception.key, 'regexp'])) return "darkgrey"
    else return "red"
  }

  // #TODO this function is basically dupe of getScheduleText
  getExceptionText(exception, exceptionTimes) {
    if (!get(this.state, [exception.key, 'isOpen'])) return <span style={{ color: "darkgrey", marginTop: '5px' }}>Cierra</span>
    else if ((this.props.timetable.allDay && allDayRegex(exceptionTimes)) || (!this.props.timetable.allDay && regularRegex(exceptionTimes))) return null
    else return (
      <span style={{ color: "red", marginTop: '5px' }}>
        Error
        <Button
          bsSize="xsmall"
          style={{ borderRadius: "50%", marginLeft: 4 }}
          glyph="question-sign"
          tooltipText="Ayuda"
          onClick={() => this.setState({ formatHelpModal: true })}
        />
      </span>
    )
  }

  editDayExceptionOnChange(exception, evt) {
    const regexp = new RegExp(`^\\s*${regexHour}(\\s*\n+${regexHour})*\n*$`, "g").test(evt.target.value)
    this.setState({
      [exception.key]: {
        ...(this.state[exception.key]),
        value: evt.target.value, 
        regexp 
      }
    })
    if (regexp || evt.target.value == "") {
      this.props.onChange(
        editException(this.props.timetable, exception.date, evt.target.value)
      )
    }
  }

  editAllDayExceptionOnChange(exception, evt) {
    const regexp = new RegExp(`^\\s*${regexRange}(\\s*\n+${regexRange})*\n*$`, "g").test(evt.target.value)
    this.setState({
      [exception.key]: {
        ...(this.state[exception.key]),
        allDayTimes: evt.target.value, 
        regexp 
      }
    })
    if (regexp || evt.target.value == "") {
      this.props.onChange(
        editAllDayException(this.props.timetable, exception.date, evt.target.value)
      )
    }
  }

  render() {
    const { timetable, onChange } = this.props
    return (
      <React.Fragment>
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title>🎉 Excepciones</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div style={{ display: "flex", flexDirection: "row", flexWrap: 'wrap' }}>
              {
                chain(timetable.exceptions)
                  .values()
                  .filter(exc => exc.key)
                  .sortBy(['date'])
                  .value()
                  .map(exception => {
                    const exceptionTimes = timetable.allDay 
                      ? get(this.state, [exception.key, 'allDayTimes'], "") 
                      : get(this.state, [exception.key, 'value'], "")

                    return (
                      <Panel className="exception-panel" key={exception.key}>
                        <Panel.Heading>
                          <Panel.Title>{exception.date}</Panel.Title>
                          <div className="headerButtons">
                            <input
                              type="checkbox"
                              className="mycheckbox"
                              checked={!!get(this.state, [exception.key, 'isOpen'], "")}
                              onChange={evt => {
                                this.setState({
                                  [exception.key]: {
                                    ...(this.state[exception.key]),
                                    isOpen: evt.target.checked
                                  }
                                })
                                onChange(editExceptionOpen(timetable, exception.date, evt.target.checked))
                              }}
                            />
                            <Button
                              bsSize="xsmall" glyph="trash" bsStyle="danger" tooltipText="Eliminar"
                              onClick={() => this.setState({ deleteModal: true, itemToDelete: exception.date })}
                            />
                          </div>
                        </Panel.Heading>
                        <Panel.Body className={get(this.state, [exception.key, 'isOpen'], "") ? "open" : "closed"}>
                          {
                            <React.Fragment>
                              <textarea
                                disabled={!get(this.state, [exception.key, 'isOpen'], "")}
                                className="exception-textarea"
                                style={{ borderColor: this.getExceptionColor(exception) }}
                                value={exceptionTimes}
                                onChange={evt => (timetable.allDay 
                                  ? this.editAllDayExceptionOnChange(exception, evt)
                                  : this.editDayExceptionOnChange(exception, evt)
                                )}
                              />
                              <div>{this.getExceptionText(exception, exceptionTimes)}</div>
                            </React.Fragment>
                          }
                        </Panel.Body>
                        <Panel.Footer>
                          {
                            (exception.note || this.state.startedNotes[exception.key])
                              ? (
                                <MarkdownField
                                  className="note-field"
                                  onChange={x => onChange(editExceptionNote(timetable, exception.date, x))}
                                  value={exception.note}
                                  label={(<span>Nota</span>)}
                                />
                              )
                              : (
                                <React.Fragment>
                                  <label style={{ marginRight: 10, marginTop: 5 }}>Nota</label>
                                  <Button
                                    bsSize="xsmall" glyph="plus-sign" tooltipText="Añadir nota"
                                    onClick={this.startNote.bind(this, exception.key)}
                                  />
                                </React.Fragment>
                              )
                          }
                        </Panel.Footer>
                      </Panel>
                    )
                  })
              }
            </div>
            <Button
              glyph="plus"
              bsStyle="primary"
              style={{ marginTop: 5 }}
              onClick={() => this.setState({ showAddExceptionModal: true })}
              label="Añadir excepcion"
            />
          </Panel.Body>
        </Panel>
        {
          this.state.deleteModal && (
            <DeleteModal
              item={this.state.itemToDelete}
              onClose={() => this.setState({ deleteModal: false })}
              onDelete={() => {
                onChange(deleteAny(timetable, this.state.itemToDelete))
                this.setState({ deleteModal: false })
              }}
            />
          )
        }
        {
          this.state.showAddExceptionModal && (
            <AddExceptionModal
              timetable={timetable}
              onClose={() => this.setState({ showAddExceptionModal: false })}
              onChange={tt => {
                this.setState({ showAddExceptionModal: false })
                onChange(tt)
              }}
            />
          )
        }
        {
          this.state.formatHelpModal && (
            <FormatHelpModal
              isAllDay={timetable.allDay}
              onClose={() => this.setState({ formatHelpModal: false })}
            />
          )
        }
      </React.Fragment>
    )
  }
}

ExceptionsEditor.propTypes = {
  timetable: timetablePropType.isRequired,
  onChange: PropTypes.func.isRequired,
}